module.exports = __WEBPACK_EXTERNAL_MODULE_56__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"cornerstone-math","commonjs2":"cornerstone-math","amd":"cornerstone-math","root":"cornerstoneMath"}
// module id = 56
// module chunks = 0